module.exports = __webpack_public_path__ + "img/logo22.94fc8330.png";